import * as loadingState from '@dragonfruit/constants/loadingState';
import {
  UPDATE_PHONE_STAGE_ONE,
  UPDATE_PHONE_STAGE_TWO,
} from '@dragonfruit/constants/updatePhoneStages';

export const UPDATE_PHONE_INITIALIZE = 'UPDATE_PHONE_INITIALIZE';
export const UPDATE_PHONE = 'UPDATE_PHONE';
export const UPDATE_PHONE_STAGE_ONE_SUCCESS = 'UPDATE_PHONE_STAGE_ONE_SUCCESS';
export const UPDATE_PHONE_STAGE_ONE_ERROR = 'UPDATE_PHONE_STAGE_ONE_ERROR';
export const UPDATE_PHONE_COMPLETE = 'UPDATE_PHONE_COMPLETE';

export const RESEND_CONFIRMATION_CODE = 'RESEND_CONFIRMATION_CODE';
export const RESEND_CONFIRMATION_CODE_SUCCESS =
  'RESEND_CONFIRMATION_CODE_SUCCESS';
export const RESEND_CONFIRMATION_CODE_ERROR = 'RESEND_CONFIRMATION_CODE_ERROR';

export const CONFIRM_VERIFICATION_CODE = 'CONFIRM_VERIFICATION_CODE';
export const CONFIRM_VERIFICATION_CODE_SUCCESS =
  'CONFIRM_VERIFICATION_CODE_SUCCESS';
export const CONFIRM_VERIFICATION_CODE_ERROR =
  'CONFIRM_VERIFICATION_CODE_ERROR';

export const CLOSE_EDIT_PANEL = 'CLOSE_EDIT_PANEL';

export const updatePhoneInitialize = hasUnconfirmedPhone => ({
  type: UPDATE_PHONE_INITIALIZE,
  payload: {
    hasUnconfirmedPhone,
  },
});

export const updatePhone = ({ phone, userId }) => ({
  type: UPDATE_PHONE,
  payload: {
    userId,
    phone,
  },
});

export const updatePhoneStageOneSuccess = () => ({
  type: UPDATE_PHONE_STAGE_ONE_SUCCESS,
});

export const updatePhoneStageOneError = errorCode => ({
  type: UPDATE_PHONE_STAGE_ONE_ERROR,
  payload: {
    errorCode,
  },
});

export const updatePhoneComplete = () => ({ type: UPDATE_PHONE_COMPLETE });

export const resendConfirmationCode = userId => ({
  type: RESEND_CONFIRMATION_CODE,
  payload: {
    userId,
  },
});

export const resendConfirmationCodeSuccess = () => ({
  type: RESEND_CONFIRMATION_CODE_SUCCESS,
});

export const resendConfirmationCodeError = errorCode => ({
  type: RESEND_CONFIRMATION_CODE_ERROR,
  payload: {
    errorCode,
  },
});

export const confirmVerificationCode = ({ userId, code }) => ({
  type: CONFIRM_VERIFICATION_CODE,
  payload: {
    userId,
    code,
  },
});

export const confirmVerificationCodeSuccess = () => ({
  type: CONFIRM_VERIFICATION_CODE_SUCCESS,
});

export const confirmVerificationCodeError = errorCode => ({
  type: CONFIRM_VERIFICATION_CODE_ERROR,
  payload: {
    errorCode,
  },
});

export const closeEditPanel = () => ({ type: CLOSE_EDIT_PANEL });

const INIT_STATE = {
  stage: UPDATE_PHONE_STAGE_ONE,
  updatePhoneOpen: false,
  updatePhoneStatus: loadingState.EMPTY,
  resendCodeStatus: loadingState.EMPTY,
  confirmCodeStatus: loadingState.EMPTY,
  phoneVerificationStatus: false,
  errorCode: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_PHONE_INITIALIZE:
      return {
        ...state,
        stage: action.payload.hasUnconfirmedPhone
          ? UPDATE_PHONE_STAGE_TWO
          : UPDATE_PHONE_STAGE_ONE,
        updatePhoneOpen: true,
        updatePhoneStatus: loadingState.EMPTY,
        resendCodeStatus: loadingState.EMPTY,
        confirmCodeStatus: loadingState.EMPTY,
        errorCode: '',
      };
    case UPDATE_PHONE:
      return {
        ...state,
        updatePhoneStatus: loadingState.LOADING,
      };
    case UPDATE_PHONE_STAGE_ONE_SUCCESS:
      return {
        ...state,
        stage: UPDATE_PHONE_STAGE_TWO,
        errorCode: '',
      };
    case UPDATE_PHONE_STAGE_ONE_ERROR:
      return {
        ...state,
        updatePhoneStatus: loadingState.ERROR,
        errorCode: action.payload.errorCode,
      };
    case RESEND_CONFIRMATION_CODE:
      return {
        ...state,
        resendCodeStatus: loadingState.LOADING,
        errorCode: '',
      };
    case RESEND_CONFIRMATION_CODE_SUCCESS:
      return {
        ...state,
        resendCodeStatus: loadingState.READY,
        errorCode: '',
      };
    case RESEND_CONFIRMATION_CODE_ERROR:
      return {
        ...state,
        resendCodeStatus: loadingState.ERROR,
        errorCode: '',
      };
    case CONFIRM_VERIFICATION_CODE:
      return {
        ...state,
        confirmCodeStatus: loadingState.LOADING,
        errorCode: '',
      };
    case CONFIRM_VERIFICATION_CODE_SUCCESS:
      return {
        ...state,
        phoneVerificationStatus: true,
        confirmCodeStatus: loadingState.READY,
        errorCode: '',
      };
    case CONFIRM_VERIFICATION_CODE_ERROR:
      return {
        ...state,
        confirmCodeStatus: loadingState.ERROR,
        errorCode: action.payload.errorCode,
      };
    case UPDATE_PHONE_COMPLETE:
      return {
        ...state,
        updatePhoneStatus: loadingState.EMPTY,
        resendCodeStatus: loadingState.EMPTY,
        confirmCodeStatus: loadingState.EMPTY,
        stage: UPDATE_PHONE_STAGE_ONE,
        updatePhoneOpen: false,
        errorCode: '',
      };
    case CLOSE_EDIT_PANEL:
      return {
        ...state,
        updatePhoneOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getOpenStatus = state => state.updatePhone.updatePhoneOpen;
export const getErrorCode = state => state.updatePhone.errorCode;
export const getStage = state => state.updatePhone.stage;
export const getPhoneVerificationStatus = state =>
  state.updatePhone.phoneVerificationStatus;



// WEBPACK FOOTER //
// ./app/redux/updatePhone.js